import type { FaireProductEntity } from "../../entity_types/product";

export const p_7vdwkqw382: FaireProductEntity = {
  token: "p_7vdwkqw382",
  type: "product",
  name: "THE PALOMINO CANDLE",
  brandToken: "b_7ydvwmgrd6",
  brandName: "NOAH MARION",
  imageUrl:
    "https://cdn.faire.com/fastly/752c39a65d991cb3321ff51e3d2671b59741c12522a5ae00e199160615f2d3e6.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d0f0e0761ffc07c3de2fef5f4a1768b06cdefd0aefa6e1a1aa570ed91927db60.jpeg",
    "https://cdn.faire.com/fastly/a5ed90f8bcf1a20cba5e1b1e550347476988795eb43e14c2b52b22064f551f9b.jpeg",
    "https://cdn.faire.com/fastly/44c5c2c654f6622b225e5a415a5da4628e4bc2c6320083d01576f754682dcf8d.jpeg",
    "https://cdn.faire.com/fastly/d59362e995a8361383466e3bcaf11ba78b0434a5e1270ec24946f3d5367bbd34.jpeg",
    "https://cdn.faire.com/fastly/f6ecd8d1187c6ef01a3e00f28be4c44106f363cd98f467bd3e3ba9ca6f142da8.jpeg",
    "https://cdn.faire.com/fastly/f97a624d92f453b601454781cb482f0260771a21041e6334a6e7bd68cbdd1058.png",
  ],
  priceDollars: 28.8,
  description:
    "Hand Poured Organic Soy Wax\n\nRecyclable Vessel\n\n125ml - 250ml\n\nPalomino - Leather | Moss\n",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:12.754Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
